import utils from '@/mixins/utils.js'

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': 'dt_nascimento',
  Mãe: 'no_mae',
  MA: 'micro_area',
  Avaliado: {
    field: 'dt_atendimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : 'Auto referido'
    },
  },
  PA: {
    field: 'dt_pa_2',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
}

export const chartOptions = {
  chart: {
    height: 300,
    type: 'line',
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'straight',
    width: 2,
  },
  title: {
    text: 'CONSULTAS EM HIPERTENSOS E AFERIÇÃO DE PA',
    align: 'center',
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
      opacity: 0.5,
    },
  },
  xaxis: {
    categories: [],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center',
  },
  markers: {
    size: 5,
  },
  annotations: {
    yaxis: [
      {
        y: 50,
        y2: 100,
        borderColor: '',
        fillColor: '#9dc8e1',
        label: {
          text: '',
        },
      },
      {
        y: 0,
        y2: 49,
        borderColor: '',
        fillColor: '#ffcccc',
        label: {
          text: '',
        },
      },
    ],
  },
  colors: ['#008FFB', '#ff9933', '#28a745'],
}
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
export const municipioBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  xaxis: {
    categories: [
      'Denominador estimado',
      'Denominador informado',
      'Numerador',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#159794', '#8fce02', '#ffaa19', '#ff0000', '#00a4de', '#e3e2e2'],
}

export const municipioCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
                  const valor = (val / 10).toFixed(2)
                  return valor
                } */
        },
      },
    },
  },
  /*  stroke: {
            lineCap: 'round'
          }, */
  /*   colors: ['#9725b0'] */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 50) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}

export const equipeBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  /* xaxis: {
          categories: [
            '',
            '',
            '',
            '',
            ''
          ]
        }, */
  xaxis: {
    categories: [
      'Denominador informado',
      'Numerador',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#8fce02', '#ffaa19', '#ff0000', '#00a4de', '#e3e2e2'],
}

export const equipeCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
                  const valor = (val / 10).toFixed(2)
                  return valor
                } */
        },
      },
    },
  },
  /*  stroke: {
            lineCap: 'round'
          }, */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 50) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}
export const acsBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  /* xaxis: {
          categories: [
            '',
            '',
            '',
            '',
            ''
          ]
        }, */
  xaxis: {
    categories: [
      'Denominador informado',
      'Numerador',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#8fce02', '#ffaa19', '#ff0000', '#00a4de', '#e3e2e2'],
}

export const acsCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
                  const valor = (val / 10).toFixed(2)
                  return valor
                } */
        },
      },
    },
  },
  /*  stroke: {
            lineCap: 'round'
          }, */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 50) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}

export const infoHtml = `
<div id='write'  class=''><h4 id='risco-cardiovascular'><span>RISCO CARDIOVASCULAR</span></h4><hr /><p><span>As doenças cardiovasculares (DCV)  estão entre  as principais causas de morte, incapacidade do cidadão no contexto mundial e nacional. Como o controle das DCV no Brasil é desafiador e a Atenção Primária à Saúde (APS) é a porta de entrada do cidadão para a prevenção dos fatores de risco, de diagnóstico precoce e de cuidado às pessoas com DCV, instituiu-se a Estratégia de Saúde Cardiovascular (ECV) na APS, com objetivo de qualificar a atenção integral às pessoas com fatores de risco para DCV.</span></p><p><span>O </span><a href='https://www.gov.br/saude/pt-br/composicao/saps/ecv/publicacoes/instrutivo-para-profissionais-e-gestores.pdf' target='_blank'><span>instrumento para profissionais e gestores</span></a><span>, sobre a </span><strong><span>ESTRATÉGIA DE SAÚDE CARDIOVASCULAR NA ATENÇÃO PRIMÁRIA À SAÚDE</span></strong><span>. Tem orientações e recomendações sobre a implementação de ações estratégicas, uso do incentivo financeiro e critérios de Monitoramento e Avaliação da ECV.</span></p><p><span>A live transmitida no YouTube </span><a href='https://www.youtube.com/watch?v=dDC-eEKzF68' target='_blank'><span>Webinário Nacional da Estratificação do Risco Cardiovascular na Atenção Primária à Saúde</span></a><span> tem informações importantes sobre a ECV, explicando a metodologia mais recomendada para a avaliação do Risco Cardiovascular na APS com a utilização da calculadora </span><strong><a href='https://www.paho.org/cardioapp/web/#/cvrisk' target='_blank'><span>Hearts</span></a></strong><span> que está calibrada para a população brasileira.</span></p><p>&nbsp;</p><p><span>O objetivo da ECV é:</span></p><ul><li><p><span>Qualificar a atenção integral para prevenção e controle das doenças cardiovasculares na APS; </span></p></li><li><p><span>Dar suporte ao desenvolvimento de ações para prevenção e controle das doenças cardiovasculares no âmbito da APS, com ênfase às condições consideradas fatores de risco, como HAS e DM; </span></p></li><li><p><span>Promover o controle dos níveis pressóricos e glicêmicos, a adesão ao tratamento e a redução nas taxas de complicações, internações e morbimortalidade por doenças cardiovasculares.</span></p></li></ul><p><span>No portal da APS, no link </span><a href='https://aps.saude.gov.br/ape/saudecardiovascular' target='_blank'><span>Estratégia de Saúde Cardiovascular APS – ECV</span></a><span> é possível encontrar mais orientações sobre a implementação da estratégia, bem como o Monitoramento e Avaliação. </span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Levando em consideração a ECV e a recomendação do MS para o uso da calculadora Hearts, conseguimos criar um algoritmo que faz o cálculo automático da estimativa do risco cardiovascular. Para isso, os profissionais de saúde da equipe precisará registrar apenas os dados (peso, altura, colesterol total, tabagismo, diabetes e pressão arterial) no e-SUS PEC e o cálculo será feito automaticamente.</span></p></blockquote><p>&nbsp;</p><p><strong><span>Avaliação do risco cardiovascular</span></strong></p><p><span> </span></p><p><span>Pelo menos um vez por ano, últimos 12 meses, é recomendado que as pessoas com idade entre 40 e 74 anos de idade sejam atendidas na APS e tenham o risco cardiovascular avaliado e estratificado.</span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Indivíduos que estão acometidos de alguma das comorbidades:</span></p><ul><li><p><span>Doença coronariana aguda e crônica (códigos CID-10: I20, I21, I22, I23, I24, I25);</span></p></li><li><p><span>AVC isquêmico ou ataque isquêmico transitório (códigos CID-10 I60, I61, I62, I63, I64,  I678);  e</span></p></li><li><p><span>Insuficiência vascular periférica (códigos CID-10 I70 – I74, I77, I79).</span></p></li></ul><p><span>São automaticamente estratificados como de alto risco cardiovascular. Esses indivíduos devem ter registro em prontuário sobre quais condições (CID) de alto risco foram observadas.</span></p></blockquote><p>&nbsp;</p><p><span>A avaliação do </span><strong><span>Risco Cardiovascular</span></strong><span> (RCV) é o ponto de  partida, para as ações de prevenção de mortes e eventos cardiovasculares não fatais e por isso fica instituída como indicador de avaliação quadrimestral na esfera federal sobre as ações executadas na ECV a nível municipal.</span></p><p><span>É recomendada a utilização da </span><a href='https://www.paho.org/pt/hearts-nas-americas/calculadora-risco-cardiovascular' target='_blank'><span>calculadora proposta pelo HEARTS</span></a><span> e seguir as orientações contidas na </span><a href='https://bvsms.saude.gov.br/bvs/publicacoes/linha_cuidado_adulto_hipertensão_arterial.pdf' target='_blank'><span>linha de cuidado do adulto com hipertensão arterial sistêmica</span></a><span> para o cálculo do RCV.</span></p><p><span>Para sistematizar o registro no prontuário eletrônico do cidadão e ter um </span><strong><span>aumento no percentual de pessoas com risco cardiovascular avaliado</span></strong><span>, recomenda-se registrar nos atendimentos das pessoas que fazem parte do grupo de risco, quando estiver realizando a avaliação do risco cardiovascular, os códigos:</span></p><ul><li><p><span>SIGTAP 0301010382 - ESTRATIFICAÇÃO DO RISCO CARDIOVASCULAR; e</span></p></li><li><p><span>CIAP K22; ou </span></p></li><li><p><span>CID Z136, Z824. </span></p></li></ul><p>&nbsp;</p><h4 id='funcionalidades'><span>FUNCIONALIDADES</span></h4><hr /><p><span>Nesta tela (</span><strong><span>Risco Cardiovascular</span></strong><span>) você pode filtrar por </span><strong><span>Equipe</span></strong><span>, </span><strong><span>Profissional</span></strong><span> ACS ou </span><strong><span>Microárea</span></strong><span> que a pessoa está vinculada. </span></p><p>&nbsp;</p><p><strong><span>Filtro por equipe e profissional ACS ou Microárea</span></strong></p><p><span>Os filtros de nível de visualização, quando estão disponíveis permite que você selecione uma equipe (</span><strong><code>Equipes</code></strong><span>) para visualizar os dados e depois possa escolher um </span><strong><code>Profissional</code></strong><span>, geralmente um Agente Comunitário de Saúde (ACS), ou possa escolher uma </span><strong><code>Microárea</code></strong><span>. </span></p><p><span>O menor nível a ser visualizado é o </span><strong><span>Profissional</span></strong><span> (pessoas vinculadas, geralmente ao CPF do ACS) ou a </span><strong><span>Microárea</span></strong><span> (valor utilizado para delimitar a menor porção territorial dentro da equipe).</span></p><p><span> </span></p><p><strong><span>Lista</span></strong></p><hr /><p><span>A lista (</span><strong><span>Risco cardiovascular &gt;&gt; Lista</span></strong><span>) apresenta a relação nominal das pessoas preconizadas para a classificação de risco de acordo com o nível de visualização escolhido por você. </span><strong><span>Por exemplo:</span></strong><span> quando se seleciona a equipe e um profissional, então os dados em tela são daquelas cadastradas com o INE da equipe selecionada e com o CPF do profissional escolhido ou micro área.</span></p><p>&nbsp;</p><p><strong><span>Filtro risco calculado por cidadão</span></strong></p><p><span>A partir dos dados (peso, altura, colesterol total, tabagismo, diabetes e pressão arterial) registrados no e-SUS PEC pelos profissionais de saúde, é calculado o risco cardiovascular que pode ser:</span></p><ul><li><p><strong><span>Baixo (&lt; 5%) </span></strong><span>;</span></p></li><li><p><strong><span>Moderado (5% a &lt; 10%)</span></strong><span>;</span></p></li><li><p><strong><span>Alto (10% a &lt; 20%)</span></strong><span>;</span></p></li><li><p><strong><span>Muito alto (20% a &lt; 30%)</span></strong><span>;</span></p></li><li><p><strong><span>Crítico (≥30%)</span></strong><span>.</span></p></li></ul><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>A porcentagem acima estima o risco cardiovascular observando os grupos de pessoas com parâmetros semelhantes.  A interpretação é feita da seguinte forma: considerando o caso de um risco estimado de 20%, significa que se observássemos 100 pessoas de mesma idade, sexo e condições durante 10 anos, 20 dessas pessoas teriam um episódio de infarto, acidente vascular cerebral ou morte de origem cardiovascular.</span></p></blockquote><p>&nbsp;</p><p><strong><span>Baixar ou fazer o download da lista</span></strong></p><p><span>Se você desejar, pode baixar a lista nominal das pessoas conforme o risco cardiovascular em formato </span><strong><span>PDF</span></strong><span> ou </span><strong><span>XLS</span></strong><span>. Para isso, basta clicar no botão </span><strong><code>PDF</code></strong><span>.</span></p><p>&nbsp;</p><p><strong><span>Pesquisar pelo nome do cidadão</span></strong></p><p><span>Para pesquisar um cidadão e visualizar o seu risco cardiovascular, você pode digitar em </span><strong><code>Nome do cidadão</code></strong><span> e será mostrado somente aquelas que contém o termo digitado na caixa de pesquisa.</span></p><p>&nbsp;</p><p><strong><span>Tabela de dados</span></strong></p><p><span>A tabela de dados permite ordenação em formato crescente e decrescente por coluna e apresenta as seguintes informações:</span></p><ul><li><p><strong><span>Nome</span></strong><span> – nome da pessoa com hipertensão. No e-SUS, deve ser preenchido com as informações igual está no CPF;</span></p></li><li><p><strong><span>Nascimento</span></strong><span> – data de nascimento da pessoa com hipertensão. Data de nascimento do cadastro diferente da que está na receita federal invalida o cadastro com a inconsistência de data de nascimento divergente;</span></p></li><li><p><strong><span>Mãe</span></strong><span> – nome da mãe da pessoa com hipertensão informado no cadastro;</span></p></li><li><p><strong><span>MA</span></strong><span> – Número da micro área informado no cadastro da pessoa com hipertensão;</span></p></li><li><p><strong><span>Atendimento</span></strong><span> - data de último atendimento realizado por profissional médico ou enfermeiro;</span></p></li><li><p><strong><span>Aval. Risco</span></strong><span> - data do último atendimento em que foi registrada a avaliação do risco cardiovascular;</span></p></li><li><p><strong><span>CPF</span></strong><span> - número de CPF do cidadão;</span></p></li><li><p><strong><span>CNS</span></strong><span> - número de CNS do cidadão;</span></p></li><li><p><strong><span>Hipertensão</span></strong><span> - data do último atendimento registrado com avaliação de hipertensão;</span></p></li><li><p><strong><span>Diabetes</span></strong><span> - data do último atendimento registrado com avaliação de diabetes;</span></p></li><li><p><strong><span>Obesidade</span></strong><span> - data do último atendimento registrado com avaliação de obesidade;</span></p></li><li><p><strong><span>Tabagismo </span></strong><span>- data do último atendimento registrado com avaliação de tabagismo;</span></p></li><li><p><strong><span>Odonto</span></strong><span> - data do último atendimento realizado;</span></p></li><li><p><strong><span>Visita</span></strong><span> - data da última visita domiciliar realizada ao indivíduo.</span></p></li></ul><p>&nbsp;</p><p><strong><span>Fonte dos dados</span></strong></p><p><span>A </span><strong><span>Fonte</span></strong><span> mostra a origem dos dados e a data da última sincronização aqui com o sistema de Monitoramento e Avaliação na APS.</span></p></div>
`
